import MicGif from "../../components/GroupedAssets/MicGif/MicGif";
import StudentImgWithHandMobileGif from "../../components/GroupedAssets/StudentImgWithHandMobileGif/StudentImgWithHandMobileGif";
import ImageComponent from "../../components/GroupedAssets/ImageComponent/ImageComponent";
import OnlineImg from "../../assets/online.svg";
import TeacherChildImg from "../../assets/teacher-child.svg";
import holdThePhoneImg from "../../assets/hold_the_phone_img.svg";
import bringCloseToFaceImg from "../../assets/bring_close_to_face_img.svg";
import startReadingImg from "../../assets/start_reading.svg";
import leavesIcon from "../../assets/leaves.svg";
import flowerIcon from "../../assets/flower.svg";
import plantIcon from "../../assets/plant_img.svg";
import seedIcon from "../../assets/seed.svg";
import hourglassIcon from "../../assets/hourglass.svg";
import reassessmentInfoBanner from "../../assets/info.svg";
import clockIcon from "../../assets/clock_img.svg";
import percentageIcon from "../../assets/percentage.svg";
import soundWaveIcon from "../../assets/sound_wave.svg";
import varnamalaLevel from "../../assets/varnamala_level.svg";
import gradeLevel from "../../assets/grade_level.svg";
import cohortOneAudio from "../../assets/audio/cohort_1.mp3";
import cohortTwoAudio from "../../assets/audio/cohort_2.mp3";
import cohortThreeAudio from "../../assets/audio/cohort_3.mp3";
import cohortFourAudio from "../../assets/audio/cohort_4.mp3";
import assessmentImg from "../../assets/student_assessment.svg";
import dataImg from "../../assets/student_data.svg";
import graphImg from "../../assets/student_graph.svg";
import cohortImg from "../../assets/student_cohort.svg";

export const SCREENS = Object.freeze({
  RENDER_ONBOARDING_SCREEN: "showOnboardingPage",
  RENDER_NEED_PERMISSION_SCREEN: "showNeedPermissionPage",
  RENDER_INSTRUCTIONS_SCREEN: "showInstructionsPage",
  RENDER_ASSESSMENT_LOADING_SCREEN: "showAsessmentLoadingPage",
  RENDER_ASSESSMENT_SCREEN: "showAssessmentPage",
  RENDER_COHORT_VIEW_SCREEN: "showCohortViewPage",
  RENDER_COHORT_COMPARATIVE_ASSESSMENT_SCREEN:
    "showCohortComparativeAssessmentPage",
  RENDER_COHORT_LOADING_SCREEN: "showCohortLoadingPage",
  RENDER_STUDENT_COHORT_RESULT_LOADING_SCREEN:
    "showStudentCohortResultLoadingPage",
  RENDER_STUDENT_COHORT_RESULT_SCREEN: "showStudentCohortResultPage",
  RENDER_STUDENT_ASSESSMENT_RESULT_SCREEN: "showStudentAssessmentResultPage",
  RENDER_STUDENT_NO_ASSESSMENT_RESULT_SCREEN:
    "showStudentNoAssessmentResultPage",
});

export const QueryParams = Object.freeze({
  TEACHER_ID: "teacher_id",
  STUDENT_NAME: "student_name",
  STUDENT_ID: "student_id",
  CLASS: "class",
  SECTION: "section",
  SCHOOL_ID: "school_id",
  SUBJECT_ID: "subject_id",
  TOKEN: "token",
  ORGANISATION: "organisation",
  STUDENT_IDS: "student_ids",
});

export const OrganisationMapping = Object.freeze({
  demo: "generic_demo",
  pratham_demo_1: "pratham_demo_1",
  bihar_demo_1: "bihar_pilot_1",
  bihar_pilot_1: "bihar_pilot_1",
  bihar_pilot_2: "bihar_pilot_2",
  delhi_mcd_1: "delhi_mcd_1",
  bcg_rajasthan_1: "bcg_rajasthan_1",
  isaksham_pilot_2: "isaksham_pilot_2",
});

export const UrlConstants = Object.freeze({
  BASE_URL: process.env.REACT_APP_BASE_URL,
  BASE_PATH_URL: process.env.REACT_APP_BASE_PATH_URL,
  ASSESSMENT: process.env.REACT_APP_ASSESSMENT,
  DSN_SENTRY_URL: process.env.REACT_APP_DSN_SENTRY_URL,
  FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  SHOW_COMPARISON: process.env.REACT_APP_SHOW_COMPARISON === "true",
});

export const FAIL_REASON_TO_MESSAGE_KEY = Object.freeze({
  silence: "no_audio_warning",
  no_speech: "no_audio_warning",
  noise: "noise_warning",
});

export const marks = (t) => [
  {
    value: 5,
    label: t("a"),
  },
  {
    value: 7.5,
  },
  {
    value: 10,
    label: t("a"),
  },
];

export const backdropInstructionInfo = (t) => ({
  3: {
    instruction: t("hold_the_phone"),
    instructionImage: holdThePhoneImg,
    instructionImageAlt: "holding-phone-img",
  },
  2: {
    instruction: t("bring_close_to_face"),
    instructionImage: bringCloseToFaceImg,
    instructionImageAlt: "bring-close-to-face-img",
  },
  1: {
    instruction: t("start_reading"),
    instructionImage: startReadingImg,
    instructionImageAlt: "start-reading-img",
  },
});

export const shikshakInstructionContent = (t, flowType) => {
  if (flowType === "assessment") {
    return [
      {
        heading: t("instruction_1"),
        content: t("instruction_1_description"),
        gif: <ImageComponent src={OnlineImg} alt="Online Image" />,
      },
      {
        heading: t("instruction_2"),
        content: t("instruction_2_description"),
        gif: <MicGif />,
      },
      {
        heading: t("instruction_3"),
        content: t("instruction_3_description"),
        gif: <StudentImgWithHandMobileGif />,
      },
      {
        heading: t("instruction_4"),
        content: t("instruction_4_description"),
        gif: <ImageComponent src={TeacherChildImg} alt="Teacher Child" />,
      },
    ];
  }

  if (flowType === "cohort") {
    return [
      {
        heading: t("cohort_instruction_1"),
        content: t("cohort_instruction_1_description"),
        gif: <ImageComponent src={assessmentImg} alt="Student assessment" />,
      },
      {
        heading: t("cohort_instruction_2"),
        content: t("cohort_instruction_2_description"),
        gif: <ImageComponent src={graphImg} alt="Student graph" />,
      },
      {
        heading: t("cohort_instruction_3"),
        content: t("cohort_instruction_3_description"),
        gif: <ImageComponent src={dataImg} alt="Student data" />,
      },
      {
        heading: t("cohort_instruction_4"),
        content: t("cohort_instruction_4_description"),
        gif: <ImageComponent src={cohortImg} alt="Student cohort" />,
      },
    ];
  }

  return [];
};

export const steps = (t) => [
  t("loading_screen_stepper_1"),
  t("loading_screen_stepper_2"),
  t("loading_screen_stepper_3"),
];

export const cohortStaticData = {
  1: {
    title: "बीज (C1)",
    className: "beeg",
    icon: seedIcon,
    audio: cohortOneAudio,
    gifTextArray: ["प", "—", "ढ़", " ", "औ", "—", "र", " ", "ब", "—", "ढ़"],
    gifText:
      "इस समूह के विद्यार्थी वर्ण और वर्ण-मात्रा ग्रिड की डीकोडिंग बहुत कम या बिलकुल नहीं कर पाते हैं ।",
    descriptionKey: "beej_reading_cohorts_description",
    contentKey: "beej_reading_cohorts_remediation",
    cardDescription:
      "इस समूह के विद्यार्थी वर्ण और वर्ण-मात्रा तालिका को बहुत कम या बिलकुल नहीं पढ़ पाते हैं।",
    content:
      "स्वर और व्यंजन की पहचान करवा कर व्यंजन के साथ एक मात्रा पर कार्य करना और ऐसे करते करते पूरी मात्राओं का अभ्यास कराना, जैसे ‘आ’ की मात्रा लगाकर अभ्यास करवाना - ‘का, खा, चा’",
    gifSpeed: 500,
  },
  2: {
    title: "अंकुरण (C2)",
    className: "ankuran",
    icon: plantIcon,
    audio: cohortTwoAudio,
    content:
      "मात्रा वाले वर्णों को मिलाकर उच्चारण करवाना जैसे - ‘चा’ और ‘चा’ मिलकर बनेगा ‘चाचा' । इस तरह हर मात्रा पर काम। फिर दो मात्राओं के वर्ण मिलाकर उच्चारण करवाना जैसे ‘चा’ और ‘ची’ बना ‘चाची'",
    gifTextArray: ["प", "—", "ढें ", " ", "औ", "—", "र", " ", "ब", "—", "ढें"],
    gifText:
      "इस समूह के विद्यार्थी वर्ण-मात्रा ग्रिड की डीकोडिंग कर पाते हैं लेकिन ब्लेंडिंग करके शब्द नहीं पढ़ पाते हैं ।",
    descriptionKey: "ankuran_reading_cohorts_description",
    contentKey: "ankuran_reading_cohorts_remediation",
    cardDescription:
      "इस समूह के विद्यार्थी वर्ण-मात्रा तालिका पढ़ पाते हैं, लेकिन ध्वनियों को जोड़कर शब्द नहीं पढ़ पाते हैं।",
    gifSpeed: 450,
  },
  3: {
    title: "पुष्पन (C3)",
    className: "pushpan",
    icon: flowerIcon,
    audio: cohortThreeAudio,
    content:
      "छोटे छोटे वाक्य पढ़ाते हुए बड़े वाक्य पढ़ने का अभ्यास करवाना, जैसे ‘घर चलो' और ‘चलो मीना विद्यालय से घर चलो’",
    gifTextArray: ["पढें ", "—", "और", "—", "बढें"],
    gifText:
      "इस समूह के विद्यार्थी अलग-अलग शब्द पढ़ पाते हैं, लेकिन शब्दों को जोड़कर वाक्य लयपूर्वक नहीं पढ़ पाते हैं।",
    descriptionKey: "pushpan_reading_cohorts_description",
    contentKey: "pushpan_reading_cohorts_remediation",
    cardDescription:
      "इस समूह के विद्यार्थी अलग-अलग शब्द पढ़ पाते हैं, लेकिन शब्दों को जोड़कर वाक्य लयपूर्वक नहीं पढ़ पाते हैं।",
    gifSpeed: 400,
  },
  4: {
    title: "फलन (C4)",
    className: "falan",
    icon: leavesIcon,
    audio: cohortFourAudio,
    content:
      "विद्यार्थियों को जोड़ों में बिठाकर अलग अलग तरह की किताबें देना जिसे वे आपस में पढ़ें, और आपस में चर्चा करें ।",
    gifTextArray: ["पढें ", " ", "और", " ", "बढें"],
    gifText:
      "इस समूह के विद्यार्थी दिये गए अनुच्छेद को सटीकता और लयबद्धता के साथ पढ़ सकते हैं।",
    descriptionKey: "phalan_reading_cohorts_description",
    contentKey: "phalan_reading_cohorts_remediation",
    cardDescription:
      "इस समूह के विद्यार्थी दिये गए अनुच्छेद को सटीकता और लयबद्धता के साथ पढ़ सकते हैं।",
    gifSpeed: 350,
  },
  [-1]: {
    title: "समूह निर्धारित नहीं",
    className: "unassigned",
    icon: hourglassIcon,
    audio: null,
    content: null,
    gifTextArray: [],
    gifText: null,
    cardDescription:
      "ऑडियो स्पष्ट नहीं था, इसलिए पठन समूह तय नहीं हो सका। यह विद्यार्थी की वास्तविक पठन क्षमता नहीं दर्शाता।",
    infoBanner: reassessmentInfoBanner,
    gifSpeed: null,
  },
};

// API cohort values: -1, 1, 2, 3, 4. -1 is the 5th (unassigned) cohort.
export const cohortIdMap = {
  1: "beeg",
  2: "ankuran",
  3: "pushpan",
  4: "falan",
  [-1]: "unassigned",
};

export const UNASSIGNED_COHORT_ID = -1;
export const UNASSIGNED_COHORT_KEY = "unassigned";

/** Maps API cohort (-1, 1–4) to a display id; -1 (and anything else) → unassigned. */
export const normalizeCohortId = (cohortId) => {
  const n = Number(cohortId);
  if (n === 1 || n === 2 || n === 3 || n === 4) {
    return n;
  }
  return UNASSIGNED_COHORT_ID;
};

export const cohortDetailsMap = {
  beeg: {
    title: "बीज",
    rangesByGrade: {
      3: {
        cwpmRange: "0-5",
      },
      4: {
        cwpmRange: "0–10",
      },
      5: {
        cwpmRange: "0-10",
      },
      6: {
        cwpmRange: "0-15",
      },
      7: {
        cwpmRange: "0-20",
      },
      8: {
        cwpmRange: "0-20",
      },
    },
    icon: varnamalaLevel,
    iconNote: "इस चिन्ह वाले विद्यार्थी को वर्णों की ध्वनियों का ज्ञान है ",
  },
  ankuran: {
    title: "अंकुरण",
    rangesByGrade: {
      3: {
        cwpmRange: "5–25",
      },
      4: {
        cwpmRange: "10–30",
      },
      5: {
        cwpmRange: "10–30",
      },
      6: {
        cwpmRange: "15-35",
      },
      7: {
        cwpmRange: "20-40",
      },
      8: {
        cwpmRange: "20-40",
      },
    },
    icon: null,
    iconNote: null,
  },
  pushpan: {
    title: "पुष्पन",
    rangesByGrade: {
      3: {
        cwpmRange: "25-50",
      },
      4: {
        cwpmRange: "30–55",
      },
      5: {
        cwpmRange: "30–55",
      },
      6: {
        cwpmRange: "35–60",
      },
      7: {
        cwpmRange: "40-65",
      },
      8: {
        cwpmRange: "40-65",
      },
    },
    icon: null,
    iconNote: null,
  },
  falan: {
    title: "फलन",
    rangesByGrade: {
      3: {
        cwpmRange: "50 से अधिक",
      },
      4: {
        cwpmRange: "55 से अधिक",
      },
      5: {
        cwpmRange: "55 से अधिक",
      },
      6: {
        cwpmRange: "60 से अधिक",
      },
      7: {
        cwpmRange: "65 से अधिक",
      },
      8: {
        cwpmRange: "65 से अधिक",
      },
    },
    icon: gradeLevel,
    iconNote:
      "इस चिन्ह वाले विद्यार्थी धाराप्रवाह पठन के साथ वर्तमान कक्षा की स्तर का पाठ भी पढ़ सकते हैं ",
  },
  unassigned: {
    title: "समूह निर्धारित नहीं",
    rangesByGrade: {},
    icon: null,
    iconNote: null,
  },
};

export const getBorderClass = (cohortId) => {
  switch (normalizeCohortId(cohortId)) {
    case 1:
      return "beeg-border";
    case 2:
      return "ankuran-border";
    case 3:
      return "pushpan-border";
    case 4:
      return "falan-border";
    case -1:
    default:
      return "unassigned-border";
  }
};

export const classReportDetails = (t, classLength, useParamValues) => [
  { label: "School ID:", value: useParamValues?.schoolId },
  { label: `${t("class")}:`, value: useParamValues?.classNum },
  {
    label: `${t("number_of_students_assessed")}:`,
    value: classLength,
  },
  { label: `${t("section")}:`, value: useParamValues?.section },
];

export const readingCohorts = (t) => [
  {
    label: t("beej"),
    icon: seedIcon,
    description: t("beej_reading_cohorts_description"),
  },
  {
    label: t("ankuran"),
    icon: plantIcon,
    description: t("ankuran_reading_cohorts_description"),
  },
  {
    label: t("pushpan"),
    icon: flowerIcon,
    description: t("pushpan_reading_cohorts_description"),
  },
  {
    label: t("phalan"),
    icon: leavesIcon,
    description: t("phalan_reading_cohorts_description"),
  },
];

export const resultMetricExplaination = (t) => {
  return {
    cwpmRange: {
      icon: clockIcon,
      label: t("cwpm_range"),
      title: t("what_is_correct_words_per_minute"),
      description: t("what_is_correct_words_per_minute_answer"),
    },
    accuracyRange: {
      icon: percentageIcon,
      label: t("word_accuracy_range"),
      title: t("what_is_word_accuracy"),
      description: t("what_is_word_accuracy_answer"),
    },
    phonemeRange: {
      icon: soundWaveIcon,
      label: t("letter_accuracy_range"),
      title: t("what_is_letter_accuracy"),
      description: t("what_is_letter_accuracy_answer"),
    },
  };
};

export const getResultUrlParams = (useParamValues, student) => {
  const {
    organisation,
    teacherId,
    schoolId,
    subjectId,
    token,
    classNum,
    section,
  } = useParamValues;

  return `organisation=${organisation}&student_name=${student?.name}&student_id=${student?.student_id}&teacher_id=${teacherId}&school_id=${schoolId}&subject_id=${subjectId}&token=${token}&class=${classNum}&section=${section}`;
};

export const PROGRESS_ACCORDION_IDS = new Set(["moved-up", "same-cohort"]);

export const DEFAULT_ASSESSMENT_LANG = Object.freeze("hi");

export const assessmentLanguageMapping = {
  1: "hi",
  11: "hi",
  2: "en",
  12: "en",
};

// Maps subject_id to the grades for which that subject_id is valid.
// Hindi: 1 -> grades 3–5, 11 -> grades 6–8
// English: 2 -> grades 3–5, 12 -> grades 6–8
export const assessmentGradeMapping = {
  1: [3, 4, 5],
  11: [6, 7, 8],
  2: [3, 4, 5],
  12: [6, 7, 8],
};
